export default class Pager {
    constructor(callback , row_count ,page_index , page_size){
        this.pageIndex = page_index
        this.pageSize = page_size
        this.rowCount = row_count
        //
        if(!callback){
            this.callback = ()=>{
                console.log('default callback');
            }
        }else {
            this.callback = callback
        }
    }
    init(row_count ,page_index , page_size){
        this.pageIndex = page_index
        this.pageSize = page_size
        this.rowCount = row_count
    }
    setPageIndex(page_index){
        this.pageIndex = page_index
    }
    setPageSize(page_size){
        this.pageSize = page_size
    }
    setRowCount(row_count){
        this.rowCount = row_count
    }
    setStep(step) {
        this.step = step;
    }
    getPageCount(){
        return Math.ceil(this.rowCount / this.pageSize)
    }
    loadPageEvent(id){
        let _this = this;
       $(`${id} ._page_item`).click(function(){
           let page = $(this).attr("page");
           if(_this.callback){
                _this.callback(page);
           }
       });
    }
    createPagebar(callback){
        if(callback){
            this.callback = callback
        }
        let page_index = this.pageIndex ; 
        let page_size = this.pageSize ; 
        let count = this.rowCount;
        var total_page = Math.ceil(count / page_size);
        if(total_page <= 1){
            return "";
        }
        var step = this.step || 6; 
        page_index = page_index < 1 ? 1 : (page_index > total_page ? total_page : page_index);
        //计算开始页码
        var begin_page = (Math.ceil(page_index / step) - 1) * step; 
        //计算结束页面
        var end_page = (begin_page + step ) > total_page ? total_page : (begin_page + step);
        begin_page =  begin_page + 1 ; 
        if(begin_page < 1){
            begin_page = 1;
        }
        //计算上一页和下一页页面
        var prev_page = (page_index - 1) < 1 ? 1 : (page_index - 1);
        var next_page = (page_index + 1) > total_page ? total_page : (page_index + 1); 
        var html = [`<a class='_total'>第${page_index}/${total_page}页</a>`];
        if(page_index == 1){ //首页和上一页不可用
            html.push("<a href='#1'>首页</a>");
            html.push("<a href='#1' >上一页</a>");
        }else{//首页和上一页
            html.push("<a href='#1'  class='_page_item' page='1'>首页</a>");
            html.push(["<a href='#1' class='_page_item' page='", prev_page ,"'>上一页</a>"].join(""));
        }
        if(step >= total_page){
            for(var i = 1 ; i <= total_page ; i ++){
                html.push("<a href='#1'");
                if(i == page_index){
                    html.push(" class='selected' ");
                }else{ //选中没有事件
                    html.push("  class='_page_item' page='"); 
                    html.push(i) ; 
                    html.push("' ");
                }
                html.push(">");
                html.push(i);
                html.push("</a> ");
            }
        }else {
            for(var i = begin_page ; i <= end_page ; i ++){
                html.push("<a href='#1'");
                if(i == page_index){
                    html.push(" class='selected' ");
                }else{ //选中没有事件
                    html.push("  class='_page_item' page='"); 
                    html.push(i) ; 
                    html.push("' ");
                }
                html.push(">");
                html.push(i);
                html.push("</a> ");
            }
            // if(end_page < (total_page - 1)){
            //     html.push(["<a href='#1'  class='_page_item' page='", (total_page -1) ,"'>...</a>"].join(""));
            //     html.push(["<a href='#1'  class='_page_item' page='", total_page ,"'>",  total_page ,"</a>"].join(""));
            // }
        }

        
        //最后一页不允许点击下一页和尾页
        if(page_index == total_page){ 
            html.push("<a href='#1'>下一页</a>");
            html.push("<a href='#1' >末页</a>");
        }else{
            html.push(["<a href='#1'  class='_page_item' page='", next_page ,"'>下一页</a>"].join(""));
            html.push(["<a href='#1'  class='_page_item' page='", total_page ,"'>末页</a>"].join(""));
        }
        return html.join("");
    }
}